import { IApportionmentModel } from "../Interface/IApportionment";

export const Apportionment:IApportionmentModel = {
    data:[],
    error:false,
    isLoading:false
}